var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore3Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 15.1667V23.3333C24.125 23.9777 23.6213 24.5 23 24.5H5C4.37868 24.5 3.875 23.9777 3.875 23.3333V15.1667H2.75V12.8333L3.875 7H24.125L25.25 12.8333V15.1667H24.125ZM6.125 15.1667V22.1667H21.875V15.1667H6.125ZM5.04456 12.8333H22.9555L22.2804 9.33333H5.71956L5.04456 12.8333ZM7.25 16.3333H16.25V19.8333H7.25V16.3333ZM3.875 3.5H24.125V5.83333H3.875V3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore3Line);
export default __webpack_public_path__ + "static/media/store-3-line.5569c4be412c292cb30b3f8f6a752650.svg";
export { ForwardRef as ReactComponent };